// External imports
import Image from "next/image";

// Local imports
import classes from "./style.module.css";

// Onam festival banner shown in place of the install banner (malayalam only)
export default function FestivalBanner() {
  return (
    <div className={`${classes.banner}`}>
      <Image
        className={`${classes.pookalam}`}
        src="/pookalam.png"
        width={134}
        height={145}
        alt=""
        priority
      />
      <div className={`${classes.content}`}>
        <p className={`${classes.subtitle}`}>മംഗ്ലീഷ് പൂക്കളോത്സവം</p>
        <h2 className={`${classes.title}`}>
          നമുക്കൊന്നിച്ച് പൂക്കളം
          <br />
          ഒരുക്കിയാലോ?
        </h2>
      </div>
      <a
        className={`${classes.link}`}
        href="https://onam.manglish.app/?utm_source=web_editor"
        target="_blank"
      >
        പൂക്കളമിടാം
      </a>
    </div>
  );
}
